/** @jsxImportSource @emotion/react */
import type { ReactNode, FormEvent } from 'react';
import { Input } from '../../../design-system/atoms/Input/Input';
import { Button } from '../../../design-system/atoms/Button/Button';
import { cardStyle, brandStyle, fieldLabelStyle, fieldStyle, submitRowStyle, footnoteStyle } from './LoginCard.styles';

export interface LoginCardProps {
  title: ReactNode;
  subtitle?: ReactNode;
  idValue: string;
  pwValue: string;
  onChangeId: (v: string) => void;
  onChangePw: (v: string) => void;
  onSubmit: () => void;
  /** 하단 안내 문구. 예: 데모 안내. (선택) */
  footnote?: ReactNode;
}

/** 로그인 카드. 수집 관리 콘솔 진입 폼. */
export function LoginCard({
  title,
  subtitle,
  idValue,
  pwValue,
  onChangeId,
  onChangePw,
  onSubmit,
  footnote,
}: LoginCardProps) {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form css={cardStyle} onSubmit={handleSubmit}>
      <div css={brandStyle}>
        <div>{title}</div>
        {subtitle !== undefined && <p>{subtitle}</p>}
      </div>
      <label css={fieldLabelStyle}>아이디</label>
      <div css={fieldStyle}>
        <Input value={idValue} onChange={onChangeId} />
      </div>
      <label css={fieldLabelStyle}>비밀번호</label>
      <div css={fieldStyle}>
        <Input type="password" value={pwValue} onChange={onChangePw} />
      </div>
      <div css={submitRowStyle}>
        <Button type="submit">로그인</Button>
      </div>
      {footnote !== undefined && <p css={footnoteStyle}>{footnote}</p>}
    </form>
  );
}
